module.exports = __webpack_public_path__ + "assets/img/zhny.80c83893.png";